export function showHowDoesItWorksPopup(boolean){
    return {
        type: "SHOW_HOW_DOES_IT_WORKS_POPUP",
        payload: boolean
    };
}

export function showSupportDetailsPopup(boolean){
    return {
        type: "SHOW_SUPPORT_DETAILS_POPUP",
        payload: boolean
    };
}

export function showNotesPopup(boolean){
    return {
        type: "SHOW_NOTES_POPUP",
        payload: boolean
    };
}


export function tutorialPopup(boolean){
	return {
		type: "TUTORIAL_POPUP",
		payload: boolean
	};
}

export function videoPopup(videoId){
    return {
        type: "VIDEO_POPUP",
        payload: videoId
    };
}

export function userUnShareErrorPopup(response, labelName){
	return {
		type: "USER_UN_SHARE_ERROR_POPUP",
		payload: response
	};
}

export function confirmFreeLicensesPopup(object){
	return {
		type: "CONFIRM_FREE_LICENSES_POPUP",
		payload: object
	};
}

export function isAdminPopup(boolean){
	return {
		type: "IS_ADMIN_POPUP",
		payload: boolean
	};
}

export function directoryWriteErrorPopup(boolean){
	return {
		type: "DIRECTORY_WRITE_ERROR_POPUP",
		payload: boolean
	};
}

export function isProfileUpdatePropagationPopup(boolean) {
	return {
		type: 'IS_PROFILE_UPDATE_PROPAGATION_POPUP',
		payload: boolean
	}
}

export function isUpgradeToBusinessPopup(boolean) {
	return {
		type: 'IS_UPGRADE_TO_BUSINESS_POPUP',
		payload: boolean
	}
}

export function isApproveDeletionPopupShown(boolean) {
	return {
		type: 'IS_APPROVE_DELETION_POPUP_SHOWN',
		payload: boolean
	}
}

export function isRejectDeletionPopupShown(boolean) {
	return {
		type: 'IS_REJECT_DELETION_POPUP_SHOWN',
		payload: boolean
	}
}

export function isUserListAddCollaboratorsPopupShown(boolean) {
	return {
		type: 'IS_USER_LIST_ADD_COLLABORATORS_POPUP_SHOWN',
		payload: boolean
	}
}

export function isOrgUnitAccessPopupShown(boolean) {
	return {
		type: 'IS_ORG_UNIT_ACCESS_POPUP_SHOWN',
		payload: boolean
	}
}

export function isDirectoryV5AccessPopupShown(boolean) {
	return {
		type: 'IS_DIRECTORY_V5_ACCESS_POPUP_SHOWN',
		payload: boolean
	}
}

export function recordingConfirmPopupDisplay(string) {
	return {
		type: 'RECORDING_CONFIRM_POPUP_DISPLAY',
		payload: string
	}
}

export function isContactWithAiPopupShown(object) {
	return {
		type: 'IS_CONTACT_WITH_AI_POPUP_SHOWN',
		payload: object
	}
}

export function isConfirmSwitchToFreePopupShown(boolean) {
	return {
		type: 'IS_CONFIRM_SWITCH_TO_FREE_POPUP_SHOWN',
		payload: boolean
	}
}

export function isFreeEditionLabelContactLimitReachedPopupShown(boolean) {
	return {
		type: 'IS_FREE_EDITION_LABEL_CONTACT_LIMIT_REACHED_POPUP_SHOWN',
		payload: boolean
	}
}